import React from 'react';
import moment from 'moment';
import { CurrencyField, DateField, TextField } from 'framework/ui/field';
import { DataGridLayout, Filters, List } from 'framework/list';
import JournalEntryLink from 'domain/finance/journalEntry/shared/field/JournalEntryLink';
import { LedgerLink } from 'domain/shared/ledger';
import useJournalEntryService from 'domain/finance/journalEntry/useJournalEntryService';
import { DATE_FORMAT } from 'framework/utils';
import JournalEntryStaticFilters from 'domain/finance/journalEntry/shared/filter/JournalEntryStaticFilters';
import { Box, Typography } from '@mui/material';
import JournalEntryTransferField from 'domain/finance/journalEntry/shared/field/JournalEntryTransferField';

const LedgerTransfersList = ({
  title,
  filter = {},
  defaultFilter = {},
  hasAccountLinkField,
  hasTransferIdField,
}: {
  title?: string;
  filter?: Dictionary<any>;
  defaultFilter?: Dictionary<any>;
  hasAccountLinkField?: boolean;
  hasTransferIdField?: boolean;
}) => {
  const { searchTransfers, getFilterValidationSchema } = useJournalEntryService();
  const currentMonthStart = moment().startOf('month').format(DATE_FORMAT.API_ONLY_DATE);
  const currentMonthEnd = moment().endOf('month').format(DATE_FORMAT.API_ONLY_DATE);

  return (
    <Box sx={{ minHeight: '200px', position: 'relative' }}>
      <List
        getDataMethod={data => searchTransfers({ ...data, filter: { ...data.filter, ...filter } })}
        defaultFilter={{
          period: {
            ge: currentMonthStart,
            le: currentMonthEnd,
          },
          ...defaultFilter,
        }}
      >
        <>
          <Filters getValidationSchema={getFilterValidationSchema}>
            <JournalEntryStaticFilters
              title={
                title && (
                  <Typography variant="h4" color="primary">
                    {title}
                  </Typography>
                )
              }
              sx={{
                marginBottom: { xs: '28px', sm: '30px' },
                '.filter-item-wrapper': {
                  margin: 0,
                },
              }}
            />
          </Filters>
          <DataGridLayout>
            {
              [
                <JournalEntryLink source="journalEntryId" label="Journal entry #" width="20%" />,
                hasAccountLinkField && (
                  <LedgerLink source="accountId" nameSource="accountId" label="Account" width="30%" />
                ),
                hasTransferIdField && <JournalEntryTransferField source="id" label="Transfer ID" width="30%" />,
                <CurrencyField source="debit" currencySource="currency" label="Debit" width="20%" />,
                <CurrencyField source="credit" currencySource="currency" label="Credit" width="20%" />,
                <TextField source="description" label="Description" width="30%" />,
                <DateField source="asDateOf" label="Date" width="15%" />,
              ].filter(Boolean) as React.ReactElement[]
            }
          </DataGridLayout>
        </>
      </List>
    </Box>
  );
};

export default LedgerTransfersList;
